import { isBOC } from "."
let owlInstance = null
let metricInstance = null

if(isBOC) {
  const misId = sessionStorage.getItem('LOGIN_MISID') || localStorage.getItem('LOGIN_MISID') || sessionStorage.getItem('_lxsdk_cuid');
  if (misId) {
    window.owl('setDimension', {
      unionId: `${window.__process_env_appkey}|${misId}`,
    })
  }
}

export const owlReportMetrics = (valuesDic = {}, tagsDic = {}, { extraString, owlProjectName } = {}) => {
  try {
    let imetricInstance = metricInstance
    if (!imetricInstance) {
      imetricInstance = window.Owl.MetricManager()
    }
    if (owlProjectName && window.owl) {
      let newInst = window.owl('createInstance', {
        project: owlProjectName || 'com.sankuai.sailorfe.d.pc',
      })
      imetricInstance = newInst && newInst.MetricManager()
    }
    const [metricName, metricValue] = Object.entries(valuesDic)[0] || []
    metricName && imetricInstance.setMetric(metricName, metricValue)
    imetricInstance.setTags({ area: window.__initRegion, cityId: '', ...tagsDic })
    extraString && imetricInstance.setExtraData(extraString)
  } catch (error) {/* empty */}
}

/**
 * 自定义上报
 * https://km.sankuai.com/page/1291907878#id-addError
 * err 参数代表异常的基本信息，可选类型包括 String、Object 和 Error 实例：
 *  当类型为 String 时，使用字符串内容作为异常名称，无堆栈信息
 *  当类型为 Object 时，要求对象有 name 和 msg 属性，并使用 name 作为异常名称，msg 作为异常堆栈
 *  当类型为 Error 实例时，将对 err 进行解析，使用 err 的 message 属性作为异常名称，stack 属性作为异常堆栈
 * opts |选填,为对象，代表异常的补充信息，可选属性包括 category、level、tags 和 combo：
 * {
 *  category 为 String 类型，表示异常分类，可选 jsError、ajaxError、resourceError 和自定义的业务异常，默认为 jsError
 *  level 为 String 类型，表示异常等级，可选 error、warn 和 info，默认为 error
 *  tags 为 Object 类型，表示异常的自定义信息
 *  combo 为 Boolean 类型，表示是否要和其他异常延时合并上报。默认不合并上报，combo 设置为 true 时合并上报
 * }
 */
export const owlAddError = (err, opts = {}) => {
  try {
    if (window.Owl) {
      window.Owl.addError(err, { level: 'info', ...opts })
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('OWL 自定义上报异常：', e)
  }
}

// msg  |必填 String 类型
// type |选填 String 类型，表示日志类型，默认为 info,可选值 warn error
export const owlAddLog = (msg, type = 'info') => {
  try {
    if (window.Owl) {
      window.Owl.addLog(msg, type)
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('OWL addLog：', e)
  }
}

// Logan.report(fromDateString, toDateString, reportConfig)
// 捞取用户本地一周内的Logan日志内容并上报至Logan平台
// fromDateString{yyyy-MM-DD}: 上报从该天开始的日志，可为null，默认为今天。说明：前端日志在本地存储7天，因此有效的上报最早时间为6天前。
// toDateString{yyyy-MM-DD}: 上报截止到该天的日志，可为null，默认为今天。

export const loganReport = (fromDateString, toDateString) => {
  try {
    if (window.Logan) {
      window.Logan.report(fromDateString, toDateString)
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('OWL addLog：', e)
  }
}

